var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4557 6.40391C54.1438 10.459 57.1092 16.45 57.1092 23.1342C57.1092 35.3459 47.2107 45.2443 35.0004 45.2443C22.79 45.2443 12.8916 35.3459 12.8916 23.1342C12.8916 10.9238 22.79 1.02539 35.0004 1.02539C38.8121 1.02539 42.3996 1.99062 45.5291 3.68867",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0506 33.4918C25.0885 37.2871 29.7615 39.7166 35.0006 39.7166C44.158 39.7166 51.5832 32.2928 51.5832 23.134C51.5832 13.9766 44.158 6.55273 35.0006 6.55273C25.8432 6.55273 18.418 13.9766 18.418 23.134C18.418 25.3406 18.8486 27.4461 19.6334 29.3725",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4749 16.4872L33.0402 23.9218L29.5264 20.408C28.4472 19.3287 26.6973 19.3287 25.618 20.408C24.5388 21.4873 24.5388 23.2371 25.618 24.3164L31.0861 29.7844C32.1654 30.8637 33.9152 30.8637 34.9945 29.7844L44.3834 20.3956C45.4626 19.3163 45.4626 17.5664 44.3834 16.4872C43.304 15.4079 41.5541 15.4079 40.4749 16.4872Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4297 52.4949V41.9785",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0371 45.2441V67.5895C35.0371 68.8049 33.5824 69.4283 32.702 68.5902L30.1877 66.1936C29.6531 65.6863 28.815 65.6863 28.2805 66.1936L25.7648 68.5902C24.8857 69.4283 23.4297 68.8049 23.4297 67.5895V57.2795",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6455 41.9316V62.0622C46.6455 63.2769 45.1904 63.9002 44.3102 63.0628L41.7953 60.6666C41.2606 60.1582 40.4232 60.1582 39.8883 60.6666L37.3734 63.0628C36.4932 63.9002 35.0381 63.277 35.0381 62.0622V45.2439",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLoyalty);
export default __webpack_public_path__ + "static/media/brand-loyalty.d69504ee8fe2fe32724a1ad81a5b035b.svg";
export { ForwardRef as ReactComponent };